export default () => ({
  resetEmailSent: {
    width: '100%',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginTop: '32px',
  },
  button: {
    marginLeft: '10px',
  },
});
